export default "__VITE_ASSET__BocJOdMD__"